import { render, staticRenderFns } from "./Merch.vue?vue&type=template&id=3514cb95&scoped=true"
import script from "./Merch.vue?vue&type=script&lang=js"
export * from "./Merch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3514cb95",
  null
  
)

export default component.exports